import { OrderStatusTimePage } from "@/features/order-status-time/pages/OrderStatusTimePage";

import { ScriptDeliveryPage } from "./ScriptDeliveryPage";

interface ManageDeliveryPageProps {
  /** False on the legacy order-status-time route when script-delivery is not granted. */
  includeScriptDelivery?: boolean;
}

/** Script delivery (AD-3324), then order status time (AD-3323). */
export function ManageDeliveryPage({ includeScriptDelivery = true }: ManageDeliveryPageProps) {
  return (
    <div className="flex h-full flex-col gap-10 overflow-y-auto p-4">
      {includeScriptDelivery ? <ScriptDeliveryPage /> : null}
      <OrderStatusTimePage embedded={includeScriptDelivery} />
    </div>
  );
}
